// extracted by mini-css-extract-plugin
export default {"buttonBlock":"lgWidthContent_buttonBlock__8SV6N","button":"lgWidthContent_button__Gnx5z","kizButton":"lgWidthContent_kizButton__IJKVY"};